export const colors = {
    black: '#000000',
    blackHover: '#505050',

    grey: '#D2D3D2',
    greyBackground: '#F2F2F2',
    greyContrast: '#D9D9D9',
    greyDark: '#666666',
    greyHover: '#E1E1E1',
    greyLight: '#F5F5F5',
    greyLighter: '#F8F8F8',
    greyMedium: '#A3A3A3',

    primary: '#ED5A48',
    primaryHover: '#Cf4C3C',
    red: '#BE0202',
    error: '#DF5B5B',
    errorLight: '#FEEDF0',

    offWhite: '#FBFBFB',
    white: '#FFFFFF',
};
